export const WARNING_NEEDS_RESPONSE = 'warning_needs_response';
export const WARNING_UNDER_REVIEW = 'warning_under_review';
export const WARNING_CLOSED = 'warning_closed';
export const NEEDS_RESPONSE = 'needs_response';
export const UNDER_REVIEW = 'under_review';
export const CHARGE_REFUNDED = 'charge_refunded';
export const WON = 'won';
export const LOST = 'lost';

export const isDisputeResolvedStatus = (stripeStatus) => {
    switch (stripeStatus) {
        case WARNING_NEEDS_RESPONSE:
        case WARNING_UNDER_REVIEW:
        case NEEDS_RESPONSE:
        case UNDER_REVIEW:
            return false;
        default:
            return true;
    }
} 